import gsap from 'gsap';


export default class Manabi{
    
    constructor(){
        this.moveY = 0;
        this.canMove = 0;
        this.req = null;
        this.throttle = 0;
        this._init();
    }


    _init(){
        this._checkCreate();
    }

    _checkCreate(){

        setTimeout(()=>{

            if([...document.querySelectorAll('.c-talkroom__list__item')].length > 0){

                setTimeout(()=>{
                    this._setMsgDisplay();
                    this._clone();
                    this._update();
                    document.querySelector('.keijiban__main').classList.add('-active');
                }, 1000);
            }
            else{
                this._checkCreate();
            }
        }, 100);

        document.querySelector('.keijiban').classList.add('-active');
        document.querySelector('.nanchu-archives').classList.add('-active');
    }

    _setMsgDisplay(){
        const items = [...document.querySelectorAll('.c-talkroom__list__item')];
        if(items.length%2 == 1) items[items.length-1].remove();

        items.forEach(($item, idx)=>{
            const amari = idx % 4;
            if(amari===0 || amari===3) $item.classList.add('-l');
            else $item.classList.add('-s');
        });
    }

    _clone(){
        const $target = document.querySelector('.js-talkroom__user');
        const $clone = $target.cloneNode(true);
        $target.after($clone);
        this.canMove = $target.getBoundingClientRect().height;
    }

    _update(){

        if(this.throttle >= 3){
            this.moveY = (this.moveY <= this.canMove) ? this.moveY+1 : 0;
            gsap.set('.js-talkroom__user', {y:`-${this.moveY}px`});
            this.throttle = 0;
        }

        this.throttle++;
        window.requestAnimationFrame(this._update.bind(this));
    }
}
